import { useState, useEffect, useRef } from "react";
import { Card } from "primereact/card";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { Toast } from "primereact/toast";

import { MdOutlineWaterDrop } from "react-icons/md";
import emailjs from "@emailjs/browser";

import TopBar from "../Components/TopBar";
import Footer from "../Components/Footer";

export default function CoconutOilPage() {
  const [selectedIndex1, setSelectedIndex1] = useState(0);
  const [selectedIndex2, setSelectedIndex2] = useState(0);
  const [showDetails1, setShowDetails1] = useState(false);
  const [showDetails2, setShowDetails2] = useState(false);
  const [errors, setErrors] = useState<FormErrors>({});
  const location = useLocation();
  const navigate = useNavigate();
  const toast = useRef<Toast>(null);

  const goToSection = (sectionId: string) => {
    navigate("/", { state: { scrollTo: sectionId } });
  };

  const productOptions1 = [
    {
      volume: "500ml",
      title: "Family Size",
      features: ["Compact size", "Easy storage", "Trial size"],
      desc: "Perfect for small families and first-time users",
      data: "500ml Discover the ideal solution for small households and first-time users with our 500ml family size. Compact and easy to store, it’s perfect for your kitchen or bathroom without taking up space. A practical, trial-friendly choice for daily use. 100% Natural | Non-GMO | Made from Fresh Coconuts Premium Quality for Your Health",
      icon: "pi pi-heart",
      image: "/images/image10.jpg",
      highlight: true,
    },
    {
      volume: "750ml",
      title: "Standard Size",
      features: ["Best value", "Regular use", "Convenient size"],
      desc: "Most popular choice for regular use",
      data: "750ml Looking for something more than a trial size? Our 750ml bottle offers just the right balance of volume and convenience. Ideal for small families or regular users who want quality without waste. 100% Natural | Non-GMO | Made from Fresh Coconuts Premium Quality for Your Health",
      icon: MdOutlineWaterDrop,
      image: "/images/image11.jpg",
    },
    {
      volume: "1000ml",
      title: "Premium Size",
      features: ["Great value", "Multi-purpose", "Long lasting"],
      desc: "Ideal for cooking and health enthusiasts",
      data: "1000ml Our 1-litre bottle is designed for families and consistent users who value both quality and quantity. A popular choice for cooking, skincare, and haircare routines. 100% Natural | Non-GMO | Made from Fresh Coconuts Premium Quality for Your Health",
      icon: "pi pi-star",
      image: "/images/image13.jpg",
    },
    {
      volume: "2000ml",
      title: "Bulk Size",
      features: ["Best savings", "Commercial use", "Bulk benefits"],
      desc: "Perfect for businesses and large families",
      data: "2000ml For households that use coconut oil every day, our 2-litre family pack is the ultimate choice. Enjoy bulk savings and fewer refills — perfect for heavy use in cooking or wellness routines. 100% Natural | Non-GMO | Made from Fresh Coconuts Premium Quality for Your Health",
      icon: "pi pi-shield",
      image: "/images/image12.jpg",
    },
  ];

  const productOptions2 = [
    {
      volume: "1Kg",
      title: "Family Size",
      features: ["Compact size", "Easy storage", "Trial size"],
      desc: "Perfect for small families and first-time users",
      data: "1Kg Discover the ideal solution for small households and first-time users with our 1Kg family size. Compact and easy to store, it’s perfect for your kitchen. A practical, trial-friendly choice for daily use. 100% Natural | Non-GMO | Premium Quality for Your Health",
      //icon: 'pi pi-heart',
      image: "/images/image8.png",
      highlight: true,
    },
    {
      volume: "1Kg",
      title: "Family Size",
      features: ["Best value", "Regular use", "Convenient size"],
      desc: "Perfect for small families and first-time users",
      data: "1Kg Discover the ideal solution for small households and first-time users with our 1Kg family size. Compact and easy to store, it’s perfect for your kitchen. A practical, trial-friendly choice for daily use. 100% Natural | Non-GMO | Premium Quality for Your Health",
      //icon: MdOutlineWaterDrop,
      image: "/images/image9.png",
    },
  ];

  const features = [
    {
      icon: "pi pi-shield",
      title: "100% Natural",
      desc: "Pure coconut oil with no artificial additives or preservatives",
    },
    {
      icon: "/icons/leaf.png",
      title: "Non-GMO",
      desc: "Made from naturally grown coconuts without genetic modification",
    },
    {
      icon: "pi pi-heart",
      title: "Cholesterol Free",
      desc: "Heart-healthy option for your cooking and wellness needs",
    },
    {
      icon: "/icons/badge.png",
      title: "Aflatoxin Free",
      desc: "Rigorous quality control ensures purity and safety",
    },
    {
      icon: "/icons/drop.png",
      title: "Fresh Coconuts",
      desc: "Made from carefully selected fresh coconuts for maximum quality",
    },
    {
      icon: "/icons/lightning.png",
      title: "Special Process",
      desc: "Hygienic drying technique preserves flavor and nutrients",
    },
  ];

  /*const certifications = [
        { label: 'EU', desc: 'EU Certified' },
        { label: 'USDA', desc: 'USDA Organic' },
        { label: 'KC', desc: 'Kosher Check' },
        { label: 'ISO', desc: 'ISO Certified' }
    ];*/

  const bottleSizes = [
    { label: "500ml", value: "500ml" },
    { label: "750ml", value: "750ml" },
    { label: "1000ml", value: "1000ml" },
    { label: "2000ml", value: "2000ml" },
  ];

  const packetSizes = [
    { label: "White Raw", value: "white_raw_1kg" },
    { label: "Red Raw", value: "red_raw_1kg" },
  ];

  const productImages = [
    { image: "images/image4.jpg" },
    { image: "images/image5.jpg" },
    { image: "images/image6.jpg" },
    { image: "images/image7.jpg" },
  ];

  const [formData, setFormData] = useState<FormData>({
    fullName: "",
    email: "",
    phone: "",
    bottleSize: "",
    packetSize: "",
    message: "",
    productType: "",
    bottleCounts: {},
    packetCounts: {},
  });

  interface FormData {
    fullName: string;
    email: string;
    phone: string;
    bottleSize: string;
    packetSize: string;
    message: string;
    productType: string,
    bottleCounts: { [key: string]: string };
    packetCounts: { [key: string]: string };
  }

  type FormErrors = Partial<Record<keyof FormData, string>>;

  const images = ["/images/bg.png", "/images/bg2.png"];

  const handleChange = (
    field: keyof FormData,
    value: string | { [key: string]: string }
  ) => {
    setFormData((prev) => {
      if (field === "bottleCounts" || field === "packetCounts") {
        return {
          ...prev,
          [field]: {
            ...(prev[field] as { [key: string]: string }),
            ...(value as { [key: string]: string }),
          },
        };
      }

      return {
        ...prev,
        [field]: value as string,
      };
    });

    setErrors((prev) => ({ ...prev, [field]: undefined }));
  };

  const validateForm = () => {
    const { fullName, email, phone, message } = formData;
    const newErrors: FormErrors = {};

    if (!formData.fullName.trim()) {
      newErrors.fullName = "Full Name is required.";
    }

    if (!formData.email.trim()) {
      newErrors.email = "Email is required.";
    }

    if (!formData.phone.trim()) {
      newErrors.phone = "Phone number is required.";
    }

    if (!fullName.trim()) newErrors.fullName = "Full Name is required";
    if (!email.trim()) newErrors.email = "Email is required";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) newErrors.email = "Invalid email address";

    if (!phone.trim()) newErrors.phone = "Phone number is required";
    else if (!/^\d{7,15}$/.test(phone)) newErrors.phone = "Invalid phone number";

    if (!message.trim()) newErrors.message = "Message cannot be empty";

    if (!formData.productType) {
      newErrors.productType = "Please select a product type";
    }

    if (formData.productType === "bottle") {
      const hasBottle = Object.values(formData.bottleCounts || {}).some(
        (val) => val && parseInt(val) > 0
      );
      if (!hasBottle) {
        newErrors.bottleCounts = "Please enter at least one bottle quantity";
      }
    }

    if (formData.productType === "packet") {
      const hasPacket = Object.values(formData.packetCounts || {}).some(
        (val) => val && parseInt(val) > 0
      );
      if (!hasPacket) {
        newErrors.packetCounts = "Please enter at least one packet quantity";
      }
    }

    if (!formData.message.trim()) {
      newErrors.message = "Message is required.";
    }

    setErrors(newErrors);

    const firstError = Object.values(newErrors)[0];
    if (firstError) toast.current?.show({ severity: "error", summary: "Error", detail: firstError, life: 3000 });

    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e: { preventDefault: () => void }) => {
    e.preventDefault();

    if (!validateForm()) return;

    emailjs
      .send(
        "service_v0kdvxi",
        "template_gfdjm91",
        {
          fullName: formData.fullName,
          email: formData.email,
          phone: formData.phone,
          bottleSize: formData.bottleSize,
          packetSize: formData.packetSize,
          message: formData.message,
          bottleCounts:formData.bottleCounts,
          packetCounts:formData.packetCounts,
        },
        "SHuu_SdDbZODNvQt3"
      )
      .then(
        (result) => {
          toast.current?.show({ severity: "success", summary: "Success", detail: "Message sent successfully!", life: 3000 });
          setFormData({ fullName: "", email: "", phone: "", bottleSize: "", packetSize: "", message: "", productType: "", bottleCounts: {}, packetCounts: {} });
          setErrors({});
        },
        (error) => {
          toast.current?.show({ severity: "error", summary: "Error", detail: "Something went wrong. Please try again.", life: 3000 });
        }
      );
  };

  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % images.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [images.length]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (location.state?.scrollTo) {
      const el = document.getElementById(location.state.scrollTo);
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({ behavior: "smooth" });
        }, 100);
      }
    }
  }, [location.state]);

  return (
    <>
      <Toast ref={toast} />
      <TopBar />
      <div id="hero" className="hero-section relative overflow-hidden">
        {images.map((src, index) => (
          <img
            key={index}
            src={src}
            alt={`Slide ${index}`}
            className={`absolute top-0 left-0 w-full h-full object-cover transition-opacity duration-1000 ${index === currentIndex ? "opacity-100" : "opacity-0"
              }`}
          />
        ))}

        <div className="absolute top-0 left-0 w-full h-full bg-black opacity-30"></div>

        {/*<div className="flex flex-column justify-content-end align-items-center w-full h-full px-4 pb-4 md:pb-6 lg:pb-8 relative z-10">
          <Button
            label="Explore Our Products"
            className="text-lg btn-1"
            onClick={() => goToSection("products")}
          />
        </div>*/}

        <div className="absolute bottom-4 flex gap-2 justify-content-center w-full z-10">
          {images.map((_, index) => (
            <span
              key={index}
              onClick={() => setCurrentIndex(index)}
              className={`w-3 h-3 border-circle cursor-pointer ${currentIndex === index ? "bg-white" : "bg-gray-400"
                }`}
            />
          ))}
        </div>
      </div>

      <div id="products" className="p-4 md:p-6">
        <div className="text-2 text-5xl font-bold mb-7 text-center">
          OUR PRODUCT RANGE
        </div>
        {/*<p className="text-lg md:text-4 text-4 mb-7 text-center">
          Choose from our carefully sized range of pure coconut oil bottles, each crafted to<br>
          </br>meet your specific needs
        </p>*/}

        <div
          id="coconutoil"
          className="text-2 text-3xl font-bold mb-7 text-center"
        >
          COCONUT OIL PRODUCTS
        </div>

        <div className="grid md:flex">
          {productOptions1.map((product, i) => {
            const isSelected = selectedIndex1 === i;

            return (
              <div key={i} className="col-12 sm:col-6 lg:col-3 p-2">
                <Card
                  onClick={() => setSelectedIndex1(i)}
                  className={`p-4 h-full text-center border-round-lg shadow-2 cursor-pointer ${isSelected ? "border-3" : ""
                    }`}
                  style={{
                    backgroundColor: "#F7F5F2",
                    borderColor: isSelected ? "#F3D371" : "#D8D8D8",
                  }}
                  title={
                    <div className="text-center">
                      <div className="col-12 mb-3">
                        <img
                          src={product.image}
                          alt={product.title}
                          className="w-full"
                          style={{
                            objectFit: "cover",
                            height: "19rem",
                            borderRadius: "0.7rem",
                          }}
                        />
                      </div>
                      <div className="text-xl font-bold text-2 mb-2">
                        {product.volume}
                      </div>
                      <div className="text-md font-medium text-4">
                        {product.title}
                      </div>
                    </div>
                  }
                  footer={
                    <Button
                      label="View More"
                      className="mt-3 w-full"
                      outlined={!isSelected}
                      onClick={() => {
                        setSelectedIndex1(i);
                        setShowDetails1(true);
                      }}
                      style={
                        isSelected
                          ? {
                            backgroundColor: "#F3D371",
                            border: "#F3D371",
                            color: "#000000",
                          }
                          : {
                            backgroundColor: "#1C9625",
                            borderColor: "#198754",
                            color: "#ffffff",
                          }
                      }
                    />
                  }
                >
                  <div className="text-center text-md font-medium text-4 mb-5">
                    {product.desc}
                  </div>
                  <ul className="list-none p-0 m-0 mt-2 text-center">
                    {product.features.map((feature, j) => (
                      <li key={j} className="text-4 text-sm mb-3">
                        • {feature}
                      </li>
                    ))}
                  </ul>
                </Card>
              </div>
            );
          })}
        </div>

        <Dialog
          header={
            <div className="flex justify-content-between align-items-center flex-wrap">
              <h2 className="m-0 text-3xl font-bold">
                {productOptions1[selectedIndex1].title}
              </h2>
              <span className="font-bold text-3xl text-2">
                {productOptions1[selectedIndex1].volume}
              </span>
            </div>
          }
          visible={showDetails1}
          style={{ width: "100%", maxWidth: "22rem" }}
          modal
          onHide={() => setShowDetails1(false)}
          closeOnEscape
          dismissableMask
          draggable={false}
        >
          <img
            src={productOptions1[selectedIndex1]?.image}
            alt={productOptions1[selectedIndex1]?.title}
            className="w-full mb-2"
            style={{
              objectFit: "cover",
              height: "25rem",
              borderRadius: "1rem",
            }}
          />

          {/*<div className="grid">
            <div className="col-12 sm:col-6 mb-3 sm:mb-0">
                <img
                    src="/images/image1.png"
                    alt={`${productOptions1[selectedIndex1].title} left`}
                    className="w-full border-round"
                />
            </div>
            <div className="col-12 sm:col-6">
                <img
                    src="/images/image2.png"
                    alt={`${productOptions1[selectedIndex1].title} right`}
                    className="w-full border-round"
                />
            </div>
          </div>*/}

          <div className="grid mb-2">
            <div className="col-6">
              <Button
                label="Contact Us"
                className="button btn-2 w-full"
                onClick={() => {
                  setShowDetails1(false);
                  setTimeout(() => {
                    goToSection("getintouch");
                  }, 300);
                }}
              />
            </div>
            <div className="col-6">
              <Button
                label="Quick Order"
                className="button btn-4 w-full"
                onClick={() => {
                  setShowDetails1(false);
                  setTimeout(() => {
                    goToSection("getintouch");
                  }, 300);
                }}
              />
            </div>
          </div>

          <div className="line-height-3 text-sm md:text-base">
            <span className="font-bold">
              {productOptions1[selectedIndex1].desc}
            </span>
            <br className="mb-2" />
            <span>{productOptions1[selectedIndex1].data}</span>
          </div>
        </Dialog>

        <p className="mt-7 mb-4 text-lg text-4 text-center">
          All sizes available for immediate order. Contact us for bulk pricing
          and special <br /> requirements.
        </p>

        <div
          id="stringhoppers"
          className="text-2 text-3xl font-bold mb-7 text-center"
          style={{ marginTop: "7rem" }}
        >
          STRING HOPPERS PRODUCTS
        </div>

        <div className="grid">
          {productOptions2.map((product, i) => {
            //const IconComponent = product.icon;
            const isSelected = selectedIndex2 === i;

            return (
              <div key={i} className="col-12 md:col-6 p-2">
                <Card
                  onClick={() => setSelectedIndex2(i)}
                  className={`p-4 h-full text-center border-round-lg borde-3 shadow-2 cursor-pointer ${isSelected ? "border-3" : ""
                    }`}
                  style={{
                    backgroundColor: "#F7F5F2",
                    borderColor: isSelected ? "#F3D371" : "#D8D8D8",
                  }}
                  title={
                    <div className="text-center">
                      {/*<span
                          className="inline-flex align-items-center justify-content-center border-circle"
                          style={{
                              backgroundColor: isSelected ? '#eab308' : '#198754',
                              width: '5rem',
                              height: '5rem',
                          }}
                      >
                          {typeof product.icon === 'string' ? (
                              <i className={`${product.icon} text-3xl`} style={{ color: isSelected ? '#000000' : '#ffffff' }} />
                          ) : (
                              <IconComponent size={39} style={{ color: isSelected ? '#000000' : '#ffffff' }} />
                          )}
                      </span>*/}
                      <div className="col-12">
                        <img
                          src={product.image}
                          alt={product.title}
                          className="w-full"
                          style={{
                            objectFit: "cover",
                            height: "25rem",
                            borderRadius: "0.7rem",
                          }}
                        />
                      </div>
                      <div className={"text-xl font-bold text-2 mb-2"}>
                        {product.volume}
                      </div>
                      <div className="text-md font-medium text-4">
                        {product.title}
                      </div>
                    </div>
                  }
                  footer={
                    <Button
                      label="View More"
                      className="mt-3 w-full"
                      outlined={!isSelected}
                      onClick={() => {
                        setSelectedIndex2(i);
                        setShowDetails2(true);
                      }}
                      style={
                        isSelected
                          ? {
                            backgroundColor: "#F3D371",
                            border: "#F3D371",
                            color: "#000000",
                          }
                          : {
                            backgroundColor: "#1C9625",
                            borderColor: "#198754",
                            color: "#ffffff",
                          }
                      }
                    />
                  }
                >
                  <div className="text-center text-md font-medium text-4 mb-5">
                    {product.desc}
                  </div>
                  <ul className="list-none p-0 m-0 mt-2 text-center">
                    {product.features.map((feature, j) => (
                      <li key={j} className="text-4 text-sm mb-3">
                        • {feature}
                      </li>
                    ))}
                  </ul>
                </Card>
              </div>
            );
          })}
        </div>

        <Dialog
          header={
            <div className="flex justify-content-between align-items-center mb-3">
              <h2 className="m-0 text-3xl font-bold">
                {productOptions2[selectedIndex2].title}
              </h2>
              <span className="font-bold text-3xl text-2">
                {productOptions2[selectedIndex2].volume}
              </span>
            </div>
          }
          visible={showDetails2}
          style={{ width: "100%", maxWidth: "22rem" }}
          modal
          onHide={() => setShowDetails2(false)}
          closeOnEscape
          dismissableMask
          draggable={false}
        >
          {/*<img
              src="/images/image.png"
              alt={productOptions2[selectedIndex].title}
              className="w-full border-round mb-3"
              style={{ objectFit: 'cover', height: '180px' }}
          />*/}

          <div className="grid">
            <img
              src={productOptions2[selectedIndex2]?.image}
              alt={productOptions2[selectedIndex2]?.title}
              className="w-full mb-3"
              style={{
                objectFit: "cover",
                height: "25rem",
                borderRadius: "1rem",
              }}
            />
          </div>

          <div className="grid">
            <div className="col-6">
              <Button
                label="Contact Us"
                className="button btn-2 w-full"
                onClick={() => {
                  setShowDetails2(false);
                  setTimeout(() => {
                    goToSection("getintouch");
                  }, 300);
                }}
              />
            </div>
            <div className="col-6">
              <Button
                label="Quick Order"
                className="button btn-4 w-full"
                onClick={() => {
                  setShowDetails2(false);
                  setTimeout(() => {
                    goToSection("getintouch");
                  }, 300);
                }}
              />
            </div>
          </div>

          <p className="mt-3 mb-4 text-900 line-height-3 text-sm md:text-base">
            <span className="font-bold">
              {productOptions2[selectedIndex2].desc}
            </span>
            <br className="mb-2" />
            <span>{productOptions2[selectedIndex2].data}</span>
          </p>
        </Dialog>

        <p className="mt-7 mb-4 text-lg text-4 text-center">
          All sizes available for immediate order. Contact us for bulk pricing
          and special<br></br> requirements.
        </p>

        {/*<div className='flex justify-content-center'>
                <Button
                    label="Quick Order"
                    className="mt-3 mx-auto btn-1"
                />
        </div>*/}
      </div>

      <div
        id="benefits"
        className="p-4 md:p-6"
        style={{ backgroundColor: "#F7F5F2" }}
      >
        <div className="text-center mb-5">
          <h2 className="text-2 text-5xl font-bold mb-5 text-center">
            OUR SPECIALITY
          </h2>
          <p className="text-lg md:text-4 text-4 mb-7 text-center">
            SNS GREEN BLEND Coconut Oil is made from 100% whole coconut kernels,
            carefully selected from freshly picked coconuts<br></br>grown in our
            local area. We use a specially developed drying technique to
            preserve the natural richness,<br></br>flavor, and aroma of
            thecoconuts, ensuring an authentic and premium-quality oil in every
            drop.
          </p>
        </div>

        <div className="grid">
          {features.map((item, idx) => (
            <div key={idx} className="col-12 md:col-4 p-3">
              <Card
                className="h-full text-left p-4"
                style={{
                  width: "100%",
                  height: "100%",
                  borderRadius: "0.5rem",
                }}
                header={
                  <div className="flex justify-content-center mb-3">
                    <span
                      className="flex align-items-center justify-content-center border-circle"
                      style={{
                        width: "6rem",
                        height: "6rem",
                        background: "#F7F5F2",
                      }}
                    >
                      {item.icon?.startsWith("/icons") ? (
                        <img
                          alt="feature icon"
                          src={item.icon}
                          style={{ width: "2.3rem", height: "2.rem" }}
                        />
                      ) : (
                        <i className={`${item.icon} text-5xl text-5`} />
                      )}
                    </span>
                  </div>
                }
              >
                <div className="flex flex-column align-items-center justify-content-center py-3 text-center">
                  <div className="mb-2 text-2xl text-4 font-bold">
                    {item.title}
                  </div>
                  <p className="text-lg">{item.desc}</p>
                </div>
              </Card>
            </div>
          ))}
        </div>
      </div>

      {/*<div className="mb-4">
          <div className="text-center mb-6">
              <h3 className="text-2 text-5xl font-bold mb-5 text-center">CERTIFIED QUALITY YOU CAN TRUST</h3>
          </div>
          <div className="p-4 grid grid-nogutter justify-content-center md:flex gap-8">
              {certifications.map((cert, idx) => (
                  <div key={idx} className="flex flex-column align-items-center">
                      <span
                          className="flex align-items-center justify-content-center border-circle mb-4"
                          style={{
                              width: '6rem',
                              height: '6rem',
                              background: 'linear-gradient(135deg, #1C9625, #09300C)'
                          }}
                      >
                          <label className="font-bold text-xl text-1">{cert.label}</label>
                      </span>
                      <span className="mt-2 font-semibold text-2xl text-4">{cert.desc}</span>
                  </div>
              ))}
          </div>
      </div>*/}

      <div className="grid p-4">
        {productImages.map((item, idx) => (
          <div key={idx} className="col-12 md:col-3 p-2">
            <div className="col-12">
              <img
                src={item.image}
                alt="Oil bottles"
                className="w-full"
                style={{
                  objectFit: "cover",
                  borderRadius: "0.7rem",
                  height: "12rem",
                }}
              />
            </div>
          </div>
        ))}
      </div>

      <div
        id="getintouch"
        className="p-4 md:p-6 text-center"
        style={{ backgroundColor: "#F7F5F2" }}
      >
        <h2 className="text-2 text-5xl font-bold mb-5 text-center">
          GET IN TOUCH
        </h2>
        <p className="text-lg md:text-4 text-4 mb-7 text-center">
          Ready to experience the pure goodness of SNS Green Blend coconut oil?
          Contact <br></br>us for orders, bulk pricing, or any questions you may
          have.
        </p>

        <form onSubmit={handleSubmit}>
          <div className="grid grid-nogutter md:w-8 mx-auto gap-3">
            <div className="col-12">
              <InputText
                className={`w-full mb-1 ${errors.fullName ? "p-invalid" : ""}`}
                placeholder="Full Name"
                value={formData.fullName}
                onChange={(e) => handleChange("fullName", e.target.value)}
                style={{ backgroundColor: "#ECECEC" }}
              />
              {errors.fullName && (
                <small className="p-error flex justify-content-left m-1">
                  {errors.fullName}
                </small>
              )}
            </div>

            <div className="col-12">
              <InputText
                className={`w-full mb-1 ${errors.email ? "p-invalid" : ""}`}
                placeholder="Email Address"
                value={formData.email}
                onChange={(e) => handleChange("email", e.target.value)}
                style={{ backgroundColor: "#ECECEC" }}
              />
              {errors.email && (
                <small className="p-error flex justify-content-left m-1">
                  {errors.email}
                </small>
              )}
            </div>

            <div className="col-12">
              <InputText
                className={`w-full mb-1 ${errors.phone ? "p-invalid" : ""}`}
                placeholder="Phone Number"
                value={formData.phone}
                onChange={(e) => handleChange("phone", e.target.value)}
                style={{ backgroundColor: "#ECECEC" }}
              />
              {errors.phone && (
                <small className="p-error flex justify-content-left m-1">
                  {errors.phone}
                </small>
              )}
            </div>

            <div className="col-12">
              <Dropdown
                className={`w-full mb-1 text-left ${errors.productType ? "p-invalid" : ""}`}
                value={formData.productType}
                options={[
                  { label: "Select Product Type", value: "" },
                  { label: "Bottle", value: "bottle" },
                  { label: "Packet", value: "packet" },
                ]}
                style={{ backgroundColor: "#ECECEC" }}
                onChange={(e) => handleChange("productType", e.value)}
                placeholder="Select Product Type"
              />
              {errors.productType && (
                <small className="p-error flex justify-content-left m-1">
                  {errors.productType}
                </small>
              )}
            </div>

            {formData.productType === "bottle" && (
              <div className="col-12">
                <div className="border-round-lg p-3" style={{ backgroundColor: "#ECECEC" }}>
                  <div className="grid">
                    {bottleSizes.map((size, index) => (
                      <div key={index} className="col-12 md:col-6 mb-3">
                        <label className="block mb-2 m-2 text-left">{size.label}</label>
                        <InputText
                          type="number"
                          min="0"
                          className="w-full"
                          placeholder={`Number of ${size.label} bottles`}
                          value={formData.bottleCounts?.[size.value] || ""}
                          onChange={(e) =>
                            handleChange("bottleCounts", {
                              ...formData.bottleCounts,
                              [size.value]: e.target.value,
                            })
                          }
                        />
                      </div>
                    ))}
                  </div>
                </div>
                {errors.bottleCounts && (
                  <small className="p-error flex justify-content-left m-1">
                    {errors.bottleCounts}
                  </small>
                )}
              </div>
            )}

            {formData.productType === "packet" && (
              <div className="col-12">
                <div className="border-round-lg p-3" style={{ backgroundColor: "#ECECEC" }}>
                  <div className="grid">
                    {packetSizes.map((size, index) => (
                      <div key={index} className="col-12 md:col-6 mb-3">
                        <label className="block mb-2 m-2 text-left">{size.label}</label>
                        <InputText
                          type="number"
                          min="0"
                          className="w-full"
                          placeholder={`Number of ${size.label} packets`}
                          value={formData.packetCounts?.[size.value] || ""}
                          onChange={(e) =>
                            handleChange("packetCounts", {
                              ...formData.packetCounts,
                              [size.value]: e.target.value})
                          }
                        />
                      </div>
                    ))}
                  </div>
                </div>
                {errors.packetCounts && (
                  <small className="p-error flex justify-content-left m-1">
                    {errors.packetCounts}
                  </small>
                )}
              </div>
            )}

            <div className="col-12">
              <InputTextarea
                className={`w-full mb-1 ${errors.message ? "p-invalid" : ""}`}
                placeholder="Your Message"
                rows={5}
                value={formData.message}
                onChange={(e) => handleChange("message", e.target.value)}
                style={{ backgroundColor: "#ECECEC" }}
              />
              {errors.message && (
                <small className="p-error flex justify-content-left m-1">
                  {errors.message}
                </small>
              )}
            </div>

            <div className="col-12 text-center">
              <Button
                type="submit"
                label="SEND MESSAGE"
                className="w-full button btn-2 mb-1"
                style={{ height: "3.5rem" }}
              />
            </div>
          </div>
        </form>

        <div
          id="contactus"
          className="grid mt-5 gap-8 md:flex md:justify-content-center"
        >
          <div
            className="col-12 md:col-5 border-2 text-5 p-4"
            style={{ borderRadius: "0.7rem" }}
          >
            <div className="flex align-items-center mb-3 gap-4">
              <span
                className="flex align-items-center justify-content-center md:justify-content-center border-circle border-2"
                style={{
                  width: "3rem",
                  height: "3rem",
                }}
              >
                {" "}
                <i className="pi pi-map-marker text-5 text-xl" />
              </span>
              <div className="text-4 text-left">
                <strong>SNS Green Blend</strong>
                <br />
                No. 185, Track 01
                <br />
                Kattyawa, Eppawala
                <br />
                Sri Lanka
              </div>
            </div>
            <div className="flex align-items-center mb-3 gap-4">
              <span
                className="flex align-items-center justify-content-center md:justify-content-center border-circle border-2"
                style={{
                  width: "3rem",
                  height: "3rem",
                }}
              >
                <i className="pi pi-phone text-5 text-xl" />
              </span>
              <span className="text-4">+94 77 123 4567</span>
            </div>
            <div className="flex align-items-center gap-4">
              <span
                className="flex align-items-center justify-content-center md:justify-content-center border-circle border-2"
                style={{
                  width: "3rem",
                  height: "3rem",
                }}
              >
                <i className="pi pi-envelope text-5 text-xl" />
              </span>

              <span className="text-4">info@snsgreenblend.com</span>
            </div>
          </div>

          <div
            className="col-12 md:col-5 border-2 text-5 p-4"
            style={{ borderRadius: "0.7rem" }}
          >
            <div className="text-5 text-xl text-left font-bold mb-4">
              QUICK ORDER
            </div>
            <p className="mb-4 text-4 text-left ml-4">
              Call us directly for immediate orders and
              <br className="mb-3"></br> bulk pricing. Our team is ready to
              assist <br className="mb-3"></br>with your coconut oil needs.
            </p>
            <Button
              label="Quick Order"
              className="btn-5 border-none w-full"
              onClick={() => {
                goToSection("getintouch");
              }}
            />
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}